import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Share, Plus, Bell } from 'lucide-react';
import { iosNeedsInstall } from '@/config/push';

/**
 * iOS 16.4+ only allows web push inside a PWA installed to the Home Screen.
 * Shown instead of the enable-notifications button while running in Safari.
 */
export const IosInstallHint = () => {
  if (!iosNeedsInstall()) return null;

  return (
    <Card className="border-primary/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          {'\u0544\u056B\u0561\u0581\u0580\u0565\u0584 \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0568 Home Screen-\u056B\u0576'}
        </CardTitle>
        <CardDescription>
          {'iOS-\u0578\u0582\u0574 push \u056E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u0568 \u0561\u0577\u056D\u0561\u057F\u0578\u0582\u0574 \u0565\u0576 \u0574\u056B\u0561\u0575\u0576 Home Screen-\u056B\u0581 \u0562\u0561\u0581\u057E\u0561\u056E \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0578\u0582\u0574 (iOS 16.4+)\u0589'}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <div className="flex items-center gap-3">
          <Share className="h-4 w-4 text-primary" />
          <span>
            {'1. Safari-\u056B \u0576\u0565\u0580\u0584\u0587\u0578\u0582\u0574 \u057D\u0565\u0572\u0574\u0565\u0584 Share \u056F\u0578\u0573\u0561\u056F\u0568'}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Plus className="h-4 w-4 text-primary" />
          <span>{'2. \u0538\u0576\u057F\u0580\u0565\u0584 \u00AB\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0567\u056F\u0580\u0561\u0576\u056B\u0576\u00BB (Add to Home Screen)'}</span>
        </div>
        <div className="flex items-center gap-3">
          <Bell className="h-4 w-4 text-primary" />
          <span>
            {'3. \u0532\u0561\u0581\u0565\u0584 \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0568 \u0567\u056F\u0580\u0561\u0576\u056B\u0581 \u0587 \u0574\u056B\u0561\u0581\u0580\u0565\u0584 \u056E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u0568'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};
